import React from 'react';
import _ from 'lodash';

import { ProductGroupFilter } from '@occc/graphql';
import { useGetProductGroups } from '@occc-app/dataAccessLayer/productGroup/queries';
import { useChainId } from '@occc-app/Chain/hooks';

import { ExistingProductGroupsRenderCallback } from '../types';

const makeFilter = (chainId: string, filters: ProductGroupFilter) => {
  const filter: ProductGroupFilter = {
    isDeleted: false,
  };
  const setFilterValue = (propName: string, propValue: any) =>
    propValue ? _.set(filter, propName, propValue) : null;
  setFilterValue('chainIdEquals', chainId);
  setFilterValue('valueContains', filters.valueContains);

  return filter;
};

interface IExistingProductGroupsContainerProps {
  configuredValues: string[];
  render: ExistingProductGroupsRenderCallback;
}
const ExistingProductGroupsContainer: React.FC<IExistingProductGroupsContainerProps> = (props) => {
  const chainId = useChainId();
  const productGroupsFilter = makeFilter(chainId, {
    valueContains: props.configuredValues,
  });
  const { data, error } = useGetProductGroups({
    filter: productGroupsFilter,
    baseOptions: {
      skip: !Array.isArray(props.configuredValues) || !props.configuredValues.length,
    },
  });

  return props.render(props.configuredValues, data, error);
};

export default React.memo(ExistingProductGroupsContainer);
